import { VistaprintAuth } from '@vp/auth-react';
import { noticeError } from 'src/utils/newRelicUtil';
import { parseAPIErrorResponse } from 'src/utils/parseAPIErrorResponse';

const webAuth = new VistaprintAuth.WebAuth();

export interface PurcsPreviewImage {
  name: string;
  title: string;
  src: string;
  srcSet: string;
}

export interface CimpressUpload {
  uploadId: string;
  uploadedFileName: string;
}

export const getFileUri = (uploadId: string): string => {
  return `https://uploads.documents.cimpress.io/v1/uploads/${uploadId}?tenant=designtechprod`;
};

export const getThumbnailUrl = (uploadId: string): string => {
  return `https://uploads.documents.cimpress.io/v1/uploads/${uploadId}/thumb?tenant=designtechprod`;
};

let uploadUrlPromise: Promise<string> | string = '';

const getUploadUrlPromise = async (process: string): Promise<string> => {
  try {
    const response = await fetch(`https://uploads.design.vpsvc.com/api/v1/uploads/postUrl?process=${process}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${webAuth.getToken()}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Invalid response getting the upload URL: ${await parseAPIErrorResponse(response)}`);
    }

    const json = await response.json();

    return json.postUrl;
  } catch (error) {
    noticeError(error, {
      process: process,
    });
    throw new Error(`Error getting the upload URL: ${(error as Error).message}`);
  }
};

export const getUploadUrl = async (process: string): Promise<string> => {
  if (!uploadUrlPromise) {
    uploadUrlPromise = getUploadUrlPromise(process);
  }

  return uploadUrlPromise;
};
